import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=998f4786&scoped=true&"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=998f4786&lang=less&scoped=true&"
import style1 from "./WithdrawRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998f4786",
  null
  
)

export default component.exports